<template>
  <b-input-group>
    <b-form-input
      type="text"
      :value="value"
      placeholder="dd/mm/aaaa"
      v-mask="[ '##/##/####' ]"
      @input="$emit('input', $event)"
      :required="required"
    />
    <b-form-datepicker 
    :value="transformValue"
    label-no-date-selected="Data não selecionada"
    label-reset-button="Resetar"
    label-next-month="Próximo mês"
    label-prev-month="Voltar mês"
    label-next-year="Próximo ano"
    label-calendar="Calendário"
    locale="pt-br"
    button-only
    right
    label-prev-year="Voltar ano"
    label-today="Hoje"
    label-help="Use os botões"
    label-today-button="Selecionar hoje"
    @input="transformEvent($event)"/>
  </b-input-group>

</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    required: {
      required: false,
      type: Boolean
    }
  },
  computed: {
    transformValue () {
      if (this.value === undefined) return undefined
      const [ day, month, year ] = this.value.split('/')
      return `${year}-${month}-${day}`
    }
  },
  methods: {
    transformEvent (date) {
      const [ year, month, day ] = date.split('-')
      this.$emit('input', `${day}/${month}/${year}`)
    }
  }
}
</script>

<style lang="scss">
.b-form-datepicker {
   > button {
    background-color: $dark;
    border-radius: 0;
  }
}
</style>